import(/* webpackMode: "eager" */ "/tmp/8dee0cb9639da04/app/[locale]/error.tsx");
